import * as React from 'react';
import { useEditorContext } from '../editor_context';
import { InsertImageButton } from './buttons';
import { MenuSeparator } from './MenuSeparator';
import { VideoInsertDropdown } from './VideoInsertDropdown';

const extensionToButtons = {
   mediaManager: [<InsertImageButton key="mediaManager" />],
   video: [<VideoInsertDropdown key="video" />],
};

type Extension = keyof typeof extensionToButtons;

interface MediaMenuItemProps {
   extension: Extension;
}

const MediaMenuItem = (props: MediaMenuItemProps) => {
   return <>{extensionToButtons[props.extension]}</>;
};

interface MediaMenuProps {
   preSeparator?: boolean;
   postSeparator?: boolean;
}

export const MediaMenu = (props: MediaMenuProps) => {
   const { editor } = useEditorContext();

   const buttons = (Object.keys(extensionToButtons) as Extension[])
      .filter(extension => extension in editor.storage)
      .map(extension => <MediaMenuItem extension={extension} key={extension} />);

   if (!buttons.length) {
      return null;
   }

   return (
      <>
         {props.preSeparator ? <MenuSeparator /> : null}
         {buttons}
         {props.postSeparator ? <MenuSeparator /> : null}
      </>
   );
};
